var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartJsx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Next"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Buble"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Accept"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Reject"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "User"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "About"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Cart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7627,7.3535C27.5728,7.1289,27.2939,7,27,7H8.5664L7.9663,4.7432C7.8501,4.3047,7.4531,4,7,4H4C3.4478,4,3,4.4473,3,5   s0.4478,1,1,1h2.231l3.8027,14.3047c0.0146,0.0557,0.0459,0.1016,0.0693,0.1523c0.022,0.0479,0.0366,0.1006,0.0659,0.1445   c0.0332,0.0498,0.0791,0.0879,0.1201,0.1309c0.0342,0.0352,0.0625,0.0771,0.1016,0.1074c0.0474,0.0352,0.1025,0.0566,0.1553,0.084   c0.0439,0.0234,0.083,0.0527,0.1299,0.0693C10.7783,21.0283,11,21.0234,11,21.0234V21h14c0.4893,0,0.9063-0.3301,0.9863-0.8125   l2-12.0352C28.0347,7.8623,27.9526,7.5771,27.7627,7.3535z M24.1523,19H11.7817l-1.0078-4h14.0503L24.1523,19z M25.1563,13H10.2759   L9.2798,9h16.5405L25.1563,13z M15,24c0,1.1045-0.8955,2-2,2s-2-0.8955-2-2s0.8955-2,2-2S15,22.8955,15,24z M25,24   c0,1.1045-0.8955,2-2,2s-2-0.8955-2-2s0.8955-2,2-2S25,22.8955,25,24z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Sound"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "List"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Settings"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartJsx);
export default __webpack_public_path__ + "static/media/cart_jsx.4614f0967923551602921909b5cd2d6c.svg";
export { ForwardRef as ReactComponent };